var _path, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoSavedCharts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.18 10L51.18 16L54 18.82L60 12.82L57.18 10ZM32 41L22 31.08L25.18 27.94L32 34.7L46.82 20L50 23.16L32 41ZM8 56V50.82L20.82 38L18 35.16L8 45.16V4H4V56C4 57.06 4.42 58.08 5.18 58.82C5.94 59.58 6.94 60 8 60H60V56H8Z",
    fill: "url(#paint0_linear_22213_23431)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22213_23431",
    x1: 4,
    y1: 32,
    x2: 60,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007BED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSavedCharts);
export default __webpack_public_path__ + "static/media/noSavedCharts.b6585a91c14c4f50d1b048b8abc004c4.svg";
export { ForwardRef as ReactComponent };